export enum ChangeStepModeEnum {
  Normal = 0,
  ReturnToStep,
  MoveToStep,
  ResetWorkflow,
  EndWorkflow,
  AdHoc,
}
